import { Table, TableBody } from "@mui/material";
import { AssignmentInd as VMIcon } from "@mui/icons-material";
import type {
  VendorProfileFacility,
  VendorProfileVendor,
} from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { formatBoolean, formatText } from "../utils/format";

type Props = {
  profile: VendorProfileFacility;
  vendor: VendorProfileVendor | null | undefined;
};

export function VMQuestionnaireSection({ profile, vendor }: Props) {
  return (
    <SectionCard icon={<VMIcon fontSize="small" />} title="VM Questionnaire">
      <Table size="small">
        <TableBody>
          <FieldRow
            label="Purpose of Onboarding"
            value={formatText(profile.purpose_of_onboarding)}
          />
          <FieldRow
            label="How Vendor Was Introduced"
            value={formatText(vendor?.how_vendor_was_introduced_to_livspace)}
          />
          <FieldRow label="Zone" value={formatText(profile.zone)} />
          <FieldRow
            label="Zone Override"
            value={formatText(profile.zone_override_if_applicable)}
          />
          <FieldRow
            label="New Vendor Onboarding Reason"
            value={formatText(profile.new_vendor_onboarding_reason)}
          />
          {profile.no_other_current_vendor != null && (
            <FieldRow
              label="No Other Vendor Currently Providing This Service"
              value={formatBoolean(profile.no_other_current_vendor)}
            />
          )}
          {profile.existing_vendor_justification != null && (
            <FieldRow
              label="Justification for Onboarding Alongside Current Vendors"
              value={formatText(profile.existing_vendor_justification)}
            />
          )}
          {profile.vendor_selection_criteria != null && (
            <FieldRow
              label="Vendor Selection Criteria"
              value={formatText(profile.vendor_selection_criteria)}
            />
          )}
          {profile.past_experience_evaluated != null && (
            <FieldRow
              label="Past Experience Evaluated"
              value={formatBoolean(profile.past_experience_evaluated)}
            />
          )}
          {profile.related_party_disclosure != null && (
            <FieldRow
              label="Related to Another Vendor or Employee"
              value={formatBoolean(profile.related_party_disclosure)}
            />
          )}
          {profile.related_party_details != null && (
            <FieldRow
              label="Related Party Details"
              value={formatText(profile.related_party_details)}
            />
          )}
          {profile.installation_vendor_training_provided != null && (
            <FieldRow
              label="Installation Training / Onboarding Call Done"
              value={formatBoolean(profile.installation_vendor_training_provided)}
            />
          )}
          {profile.groove_type != null && (
            <FieldRow label="Groove Type" value={formatText(profile.groove_type)} />
          )}
          {profile.ops_site_visit_made != null && (
            <FieldRow
              label="Site Visit of Previous Work Made"
              value={formatBoolean(profile.ops_site_visit_made)}
            />
          )}
          {profile.ops_site_visit_feedback != null && (
            <FieldRow
              label="Site Visit Feedback"
              value={formatText(profile.ops_site_visit_feedback)}
            />
          )}
          {profile.ops_work_recommendation != null && (
            <FieldRow
              label="Recommended Amount of Work"
              value={formatText(profile.ops_work_recommendation)}
            />
          )}
          <FieldRow
            label="Is Vendor Onboarded for Testing"
            value={formatBoolean(profile.is_vendor_onboarded_for_testing)}
          />
          <FieldRow
            label="Quotes Taken Over Email"
            value={formatBoolean(profile.quotes_taken_over_email)}
          />
          <FieldRow
            label="L1 Vendor Selected"
            value={formatBoolean(profile.l1_vendor_selected)}
          />
          <FieldRow
            label="Vendor Manager Email"
            value={formatText(profile.vendor_manager_email)}
          />
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default VMQuestionnaireSection;
